import React from 'react';

const ToggleSwitch = ({ checked, onChange, disabled = false }) => (
  <button
    onClick={() => !disabled && onChange(!checked)}
    disabled={disabled}
    className={`relative w-12 h-6 rounded-full transition-colors ${
      checked ? 'bg-blue-500' : 'bg-gray-300'
    } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
  >
    <div className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-transform ${
      checked ? 'translate-x-6' : 'translate-x-0.5'
    }`} />
  </button>
);

export default ToggleSwitch;